module.exports = __webpack_public_path__ + "static/media/Muli-Regular.fe9ac82e.eot";